module.exports = __webpack_public_path__ + "img/taipei.1ef9c8c7.jpg";